import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { EndOrderDetailPaymentLink, Order, PaymentMethod } from '@pedix-workspace/utils';
import { EnvironmentService } from '@pedix-workspace/angular-utils';

import { TranslocoDirective } from '@ngneat/transloco';
import { CurrencyFormatPipe } from '@pedix-workspace/pedixapp-shared-pipes';
import { DatePipe } from '@angular/common';
import { getPaymentUrl } from '@pedix-workspace/orders';
import { TagComponent, TagType } from '@pedix-workspace/angular-ui-alert';
import { IconPaymentComponent } from '@pedix-workspace/angular-ui-icons';

export type OrderListDetailRenderEvent = {
  row: Order;
  height: number;
};

@Component({
  selector: 'pxw-order-details-payment-method',
  templateUrl: './order-details-payment-method.component.html',
  styleUrls: ['./order-details-payment-method.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslocoDirective, CurrencyFormatPipe, DatePipe, TagComponent, IconPaymentComponent],
})
export class OrderDetailsPaymentMethodComponent {
  private readonly environmentService = inject(EnvironmentService);

  readonly orderId = input.required<string>();
  readonly paymentMethod = input.required<PaymentMethod>();
  readonly paymentLink = input.required<EndOrderDetailPaymentLink | null>();
  readonly howMuch = input.required<number | null>();

  readonly paymentUrl = computed(() => {
    const paymentLink = this.paymentLink();

    if (!paymentLink) {
      return null;
    }

    return getPaymentUrl(this.environmentService.siteUrl, this.orderId());
  });
  readonly paymentTagType = computed((): TagType => {
    switch (this.paymentLink()?.status) {
      case 'PAID':
        return 'success';
      case 'PENDING':
        return 'warning';
      case 'CANCELLED':
      case 'REJECTED':
        return 'danger';
      case 'REFUNDED':
        return 'info';
      default:
        return 'neutral';
    }
  });
}
